const FERIADOS_FIXOS = [
  '01-01', '25-01', '21-04', '01-05', '07-09',
  '12-10', '02-11', '15-11', '20-11', '24-12', '25-12', '31-12',
];

function easterDate(year: number): Date {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month, day);
}

function feriadosMoveis(year: number): Date[] {
  const easter = easterDate(year);
  const add = (n: number) => { const d = new Date(easter); d.setDate(d.getDate() + n); return d; };
  return [add(-48), add(-47), add(-2), easter, add(60)];
}

export function isFeriado(d: Date): boolean {
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  if (FERIADOS_FIXOS.includes(`${mm}-${dd}`)) return true;
  return feriadosMoveis(d.getFullYear()).some(
    f => f.getFullYear() === d.getFullYear() && f.getMonth() === d.getMonth() && f.getDate() === d.getDate()
  );
}

export function isWorkday(d: Date): boolean {
  const dow = d.getDay();
  return dow !== 0 && dow !== 6 && !isFeriado(d);
}

export function addDays(d: Date, n: number): Date {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}

function nthWorkdayOfMonth(year: number, month: number, n: number): Date {
  let d = new Date(year, month, 1);
  let count = 0;
  while (true) {
    if (isWorkday(d)) { count++; if (count === n) return d; }
    d = addDays(d, 1);
  }
}

function nextNthWorkdayOfMonth(from: Date, n: number): Date {
  let year = from.getFullYear();
  let month = from.getMonth();
  const candidate = nthWorkdayOfMonth(year, month, n);
  if (candidate > from) return candidate;
  month++;
  if (month > 11) { month = 0; year++; }
  return nthWorkdayOfMonth(year, month, n);
}

function nextDay20After(after: Date): Date {
  let d = new Date(after.getFullYear(), after.getMonth(), 20);
  if (d <= after) d = new Date(after.getFullYear(), after.getMonth() + 1, 20);
  return d;
}

export function calcDefaultInstallmentDates(installments: number, isCustom: boolean): Date[] {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (installments <= 3 && !isCustom) {
    const d1 = nextNthWorkdayOfMonth(today, 5);
    if (installments === 1) return [d1];
    const d2 = nextDay20After(d1);
    if (installments === 2) return [d1, d2];
    let y = d2.getFullYear();
    let m = d2.getMonth() + 1;
    if (m > 11) { m = 0; y++; }
    const d3 = nthWorkdayOfMonth(y, m, 5);
    return [d1, d2, d3];
  }

  const first = nextNthWorkdayOfMonth(today, 5);
  return Array.from({ length: installments }, (_, i) => addDays(first, i * 7));
}
